// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".plv-iar-welfare-lottery__task{position:relative;padding:8px 16px;background-color:#fff8eb;border-radius:8px;margin-bottom:20px}.plv-iar-welfare-lottery__task__title{color:#333;font-size:16px;font-weight:400;line-height:22px;margin:0;margin-bottom:4px;display:flex;align-items:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
